import { UseMutationOptions } from '@tanstack/react-query';

import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import {
  SystemTemplateResetPayload,
  SystemTemplates,
} from 'models/automation/SystemTemplates';
import API from 'services/API';

type UseResetSystemTemplateMutationArgs = SystemTemplateResetPayload & {
  key: SystemTemplates;
};

type ReactQueryMutationOptions<TContext = unknown> = Omit<
  UseMutationOptions<
    {},
    BaseErrorResponse,
    UseResetSystemTemplateMutationArgs,
    TContext
  >,
  'mutationFn' | 'mutationKey'
>;

const resetSystemTemplate = ({
  key,
  ...payload
}: UseResetSystemTemplateMutationArgs) => {
  return API.delete<{}, BaseErrorResponse>(
    `/api/internal/automation/system-templates/${key}/reset`,
    { data: payload },
  );
};

const useResetSystemTemplateMutation = <TContext>({
  ...options
}: ReactQueryMutationOptions<TContext> = {}) => {
  return useAppMutation({
    mutationFn: resetSystemTemplate,
    ...options,
  });
};

export default useResetSystemTemplateMutation;
